function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M449.35,0h-430c-6.6,0-12,5.4-12,12s5.4,12,12,12h25.9v432.4c0,4.4,2.4,8.5,6.3,10.6s8.6,1.9,12.3-0.6l52.1-34.7 l52.3,34.8c4,2.7,9.3,2.7,13.3,0l52.1-34.7l52.3,34.8c4,2.7,9.3,2.7,13.3,0l52.1-34.7l52.3,34.8c2,1.3,4.3,2,6.6,2 c1.9,0,3.9-0.5,5.7-1.4c3.9-2.1,6.3-6.2,6.3-10.6l-0.2-432.4h27.3c6.6,0,12-5.4,12-12S455.95,0,449.35,0z M398.35,434l-40.3-26.8 c-4-2.7-9.3-2.7-13.3,0l-52.1,34.8l-52.3-34.8c-4-2.7-9.3-2.7-13.3,0l-52.1,34.7l-52.3-34.7c-4-2.7-9.3-2.7-13.3,0l-40.1,26.7 v-410h329L398.35,434z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,191.6h125.7c6.6,0,12-5.4,12-12s-5.4-12-12-12h-125.7c-6.6,0-12,5.4-12,12S117.75,191.6,124.45,191.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,233.3h94.2c6.6,0,12-5.4,12-12s-5.4-12-12-12h-94.2c-6.6,0-12,5.4-12,12S117.75,233.3,124.45,233.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,191.6h31.4c6.6,0,12-5.4,12-12s-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12S306.25,191.6,312.95,191.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,233.3h31.4c6.6,0,12-5.4,12-12s-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12S306.25,233.3,312.95,233.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,95.3h125.7c6.6,0,12-5.4,12-12c0-6.6-5.4-12-12-12h-125.7c-6.6,0-12,5.4-12,12 C112.45,89.9,117.75,95.3,124.45,95.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,136.9h94.2c6.6,0,12-5.4,12-12s-5.4-12-12-12h-94.2c-6.6,0-12,5.4-12,12S117.75,136.9,124.45,136.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,95.3h31.4c6.6,0,12-5.4,12-12c0-6.6-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12C300.95,89.9,306.25,95.3,312.95,95.3 z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,136.9h31.4c6.6,0,12-5.4,12-12s-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12S306.25,136.9,312.95,136.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,289.1h125.7c6.6,0,12-5.4,12-12s-5.4-12-12-12h-125.7c-6.6,0-12,5.4-12,12S117.75,289.1,124.45,289.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.45,330.7h94.2c6.6,0,12-5.4,12-12s-5.4-12-12-12h-94.2c-6.6,0-12,5.4-12,12S117.75,330.7,124.45,330.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,289.1h31.4c6.6,0,12-5.4,12-12s-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12S306.25,289.1,312.95,289.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.95,330.7h31.4c6.6,0,12-5.4,12-12s-5.4-12-12-12h-31.4c-6.6,0-12,5.4-12,12S306.25,330.7,312.95,330.7z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBilling = function SvgBilling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.7 468.7",
    style: {
      enableBackground: "new 0 0 468.7 468.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBilling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/billing.38e23f33.svg";
export { ForwardRef as ReactComponent };